module.exports = __webpack_public_path__ + "img/image01.c5974309.jpg";